import { Component } from '@angular/core';

@Component({
  selector: 'app-view-angle',
  templateUrl: './view-angle.component.html',
  styleUrls: ['./view-angle.component.scss']
})
export class ViewAngleComponent {}
